import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PrintPurchase } from "../../Redux/Sale/action";
import { ToWords } from "to-words";
import "./print.css"
const PrintIssueReport = React.forwardRef((props, ref) => {
  const Dispatch = useDispatch();
  const TempleID = JSON.parse(localStorage.getItem("Sopanam_TempleId"));

  const PurchaseDatavalue = useSelector((state) => state.Sale.PurchaseData);
  //   const printdata = useSelector((state) => state.Sale.PrintPurchaseData);
//   const printdata = useSelector((state) => state?.Report?.transaction);
const [printdata,setPrintData]=useState([])
  // useEffect(()=>{
  // if(props.transactionId){
  //   Dispatch(PrintPurchase({ TID: props.transactionId, TempleId: TempleID }));
  // }
  // },[props.transactionId])
  useEffect(()=>{
  if(props.filteredData){
  setPrintData(props.filteredData)
  }
  },[props.filteredData])

  useEffect(() => {
    if (props.filteredData && props.filteredData.length > 0) {
        props.onDataReady(true); // Notify parent that data is ready
    } else {
        props.onDataReady(false); // Notify parent that data is not ready
    }
  }, [props.filteredData, props.onDataReady]);

  const toWords = new ToWords({
    localeCode: "en-IN",
    converterOptions: {
      currency: true,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
      doNotAddOnly: false,
      currencyOptions: {
        // can be used to override defaults for the selected locale
        name: "Rupee",
        plural: "Rupees",
        symbol: "₹",
        fractionalUnit: {
          name: "Paisa",
          plural: "Paise",
          symbol: "",
        },
      },
    },
  });

  const [totalAmount, setTotalAmount] = useState(0);
  const [fetchedQuantity, setFetchedQuantity] = useState(0);
  const [issuedQuantity, setIssuedQuantity] = useState(0);

  useEffect(() => {
    // Calculate total amount when printdata changes
    const total =
      Array.isArray(printdata) &&
      printdata.reduce((accumulator, currentItem) => {
        return accumulator + parseFloat(currentItem.Amount);
      }, 0);
    setTotalAmount(total);
  }, [printdata]);

  useEffect(() => {
    // Calculate total amount when printdata changes
    const total =
      Array.isArray(printdata) &&
      printdata.reduce((accumulator, currentItem) => {
        return accumulator + parseFloat(currentItem.FetchedQuantity);
      }, 0);
      setFetchedQuantity(total);
  }, [printdata]);

  useEffect(() => {
    // Calculate total amount when printdata changes
    const total =
      Array.isArray(printdata) &&
      printdata.reduce((accumulator, currentItem) => {
        return accumulator + parseFloat(currentItem.Quantity);
      }, 0);
      setIssuedQuantity(total);
  }, [printdata]);

  useEffect(() => {
    console.log("printdataprintdata", printdata);
  }, [printdata]);

  // Output: "nineteen point two"

  let NumberNeedToConvert = totalAmount
    ? totalAmount.toFixed(2) - (printdata[0]?.Discount || 0)
    : 0;

  function formatDate(inputDate) {
    // Create a new Date object from the input string
    const date = new Date(inputDate);

    // Extract day, month, and year from the date object
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    // Concatenate the formatted date parts
    const formattedDate = `${day}/${month}/${year}`;

    return formattedDate;
  }

  return (
    <div style={{ display: "none" }}>
      <div className="m-5   border  border-black print" ref={ref}>
        <div className="flex justify-center p-5 text-[18px] font-bold">
          {" "}
          <span className="ml-2 ">
            {printdata && printdata?.[0]?.TempleName}
          </span>
        </div>

        <div className="flex justify-center text-sm font-semibold">
            <span className="ml-2">
                {printdata[0]?.TempleAddress}
              </span></div>

        <div className="mt-2 flex justify-center border-y border-y-black p-1 text-lg font-bold">
          {`Issue Report From ${formatDate(
            printdata && printdata?.[0]?.FromDate
          )} To ${formatDate(printdata && printdata?.[0]?.ToDate)}`}
        </div>
        
        <div class="mt-2 flex flex-col">
          <div class="overflow-x-auto sm:mx-0.5 lg:mx-0.5">
            <div class="inline-block min-w-full py-2 sm:px-2 lg:px-8">
              <div class="overflow-hidden">
                <table class="min-w-full">
                  <thead
                    className="border-b bg-white text-center"
                    style={{ textAlign: "center !important" }}
                  >
                    <tr>
                      {/* <th
                        scope="col"
                        class="px-2 py-2 text-left text-sm font-medium text-gray-900"
                      >
                        Invoice No
                      </th>
                      <th
                        scope="col"
                        class="px-2 py-2 text-left text-sm font-medium text-gray-900"
                      >
                        Invoice Date
                      </th> */}
                      <th
                        scope="col"
                        class="px-2 py-2 text-center text-sm font-medium text-gray-900"
                      >
                        Bill No
                      </th>
                      <th
                        scope="col"
                        class="px-2 py-2 text-center text-sm font-medium text-gray-900"
                      >
                        Bill Date
                      </th>
                      <th
                        scope="col"
                        class="px-2 py-2 text-center text-sm font-medium text-gray-900"
                      >
                        Item Name
                      </th>
                      <th
                        scope="col"
                        class="px-2 py-2 text-center text-sm font-medium text-gray-900"
                      >
                        Party Name
                      </th>
                      <th
                        scope="col"
                        class="px-2 py-2 text-center text-sm font-medium text-gray-900"
                      >
                        Fetched Quantity
                      </th>
                      <th
                        scope="col"
                        class="px-2 py-2 text-center text-sm font-medium text-gray-900"
                      >
                        Issued Quantity
                      </th>
                      <th
                        scope="col"
                        class="px-2 py-2 text-center text-sm font-medium text-gray-900"
                      >
                        Bill Entered Date
                      </th>
                      <th
                        scope="col"
                        class="px-2 py-2 text-center text-sm font-medium text-gray-900"
                      >
                        Session
                      </th>
                      {/* <th
                        scope="col"
                        class="px-2 py-2 text-left text-sm font-medium text-gray-900"
                      >
                        Rate
                      </th>
                      <th
                        scope="col"
                        class="px-2 py-2 text-left text-sm font-medium text-gray-900"
                      >
                        Amount
                      </th> */}
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {Array.isArray(printdata) &&
                      printdata.map((row, index) => {
                        console.log(row, "row");
                        const InvoiceDate = formatDate(row.OrderDate);
                        const BillDate = formatDate(row.BillDate);
                        return (
                          <tr
                            key={index}
                            className={
                              index % 2 === 0 ? "bg-gray-100" : "bg-white"
                            }
                          >
                            {/* <td>{row.InvoiceNo}</td>
                          <td>{InvoiceDate??''}</td> */}
                            <td>{row.BillNumber}</td>
                            <td>{BillDate ?? ""}</td>
                            <td>{row.item}</td>
                            <td>{row.PartyName}</td>
                            <td>{row?.FetchedQuantity?.toFixed(2) ?? ""}</td>
                            <td>{row?.Quantity?.toFixed(2) ?? ""}</td>
                            <td>{InvoiceDate ?? ""}</td>
                            <td>{row?.SessionName ?? ""}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="flex  bg-gray-300 ">

          {/* <div className=" w-1/2">
            <div className="mr-5 text-end">
              Total Fetched Quantity &nbsp;:&nbsp; <b>{fetchedQuantity ?fetchedQuantity.toFixed(2):''}</b>{" "}
            </div>
            <div className="mr-5 text-end">
            Total Issued Quantity &nbsp;:&nbsp;<b>{issuedQuantity?issuedQuantity.toFixed(2):''}</b>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
});

export default PrintIssueReport;
